import React from 'react';
import findIndex from 'lodash/findIndex';
import TextCropper from '@omilia/text-cropper';

import './style.scss';

type InputType = {
  value:
    | string
    | {
        id: string;
        name: string;
        category?: string;
      };
};

type itemType = { archived?: boolean; name: string };

interface Props {
  item: object;
  input: InputType;
  items: itemType[];
  itemUniqueProp: string;
  itemWithIndex: boolean;
  itemIndexOffset: number;
  withDropCross: boolean;
  placeholder?: string;
  onClearButtonClick: (event: React.MouseEvent) => void;
}

const getFieldName = (
  input: InputType,
  items: itemType[],
  itemUniqueProp: string,
  itemWithIndex: boolean,
  itemIndexOffset: number,
) => {
  if (input.value) {
    if (itemWithIndex) {
      const index = findIndex(items, {
        [itemUniqueProp]: input.value[itemUniqueProp],
      });

      return `${itemIndexOffset + index + 1} - ${input.value.name}`;
    }

    return input.value.name;
  }

  return null;
};

const AutoCompleteDefaultSelectedItem = ({
  input,
  items,
  item,
  placeholder,
  itemIndexOffset,
  itemWithIndex,
  itemUniqueProp,
  withDropCross,
  onClearButtonClick,
}: Props) => {
  const buttonText =
    getFieldName(
      input,
      items,
      itemUniqueProp,
      itemWithIndex,
      itemIndexOffset,
    ) ||
    item ||
    placeholder;

  return (
    <div styleName="wrapper">
      <TextCropper key={buttonText} text={buttonText} />
      {withDropCross && input.value && (
        <i
          className="icon-close"
          data-test="clear-button"
          styleName="cross"
          onClick={onClearButtonClick}
        />
      )}
    </div>
  );
};

export default AutoCompleteDefaultSelectedItem;
